import { Link } from 'react-router-dom';
import { DECISION_JOURNEY, getWorkbookBySlug, getOutcome } from '@/data/workbooks';

interface DecisionJourneyProps {
  /** Shown above the list */
  heading?: string;
  intro?: string;
  className?: string;
}

/**
 * The action layer. The articles explain the lifestyle; this shows the
 * seven questions a reader has to answer before committing, and which
 * title answers each one.
 */
export const DecisionJourney = ({
  heading = 'Ready to make it real?',
  intro = 'Seven questions stand between reading about this life and living it. Each one has a workbook that answers it with your own numbers.',
  className = '',
}: DecisionJourneyProps) => {
  return (
    <section className={`${className}`} aria-labelledby="decision-journey-heading">
      <p className="text-[10px] tracking-luxury uppercase text-brass-deep mb-4">The action layer</p>
      <h2
        id="decision-journey-heading"
        className="font-display text-2xl md:text-3xl lg:text-4xl font-medium text-primary tracking-tight leading-[1.15]"
      >
        {heading}
      </h2>
      <p className="mt-4 text-sm md:text-base text-muted-foreground/90 font-light leading-relaxed max-w-2xl">
        {intro}
      </p>

      <ol className="mt-8 border-t border-border/40">
        {DECISION_JOURNEY.map((step, i) => {
          const workbook = getWorkbookBySlug(step.slug);
          if (!workbook) return null;
          const outcome = getOutcome(workbook.slug);
          return (
            <li
              key={step.slug}
              className="border-b border-border/40 py-5 flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6"
            >
              <span className="font-display text-sm text-brass-deep/80 w-8 shrink-0 tabular-nums">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <p className="font-serif text-base md:text-lg text-foreground leading-snug">
                  {step.question}
                </p>
                <p className="mt-1 text-[13px] text-muted-foreground/80 font-light leading-relaxed">
                  {outcome.lead}
                </p>
              </div>
              <Link
                to={`/workbooks?buy=${workbook.slug}`}
                className="text-[11px] tracking-luxury uppercase text-accent underline-offset-4 hover:underline shrink-0 sm:text-right sm:w-56"
              >
                {workbook.title} &mdash; ${workbook.price}
              </Link>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
